// extracted by mini-css-extract-plugin
export default {"cursor":"Board_cursor__+zJc0","moveCursor":"Board_moveCursor__eboWn","textElementBox":"Board_textElementBox__Jx-hy","Univ":"Board_Univ__yTeP4"};